import React, { Component } from "react";
import Registration from "./Registration";

class RegistrationPage extends Component {
  render() {
    return <Registration actionType={"registration"} />;
  }
}

export default RegistrationPage;
